import type { CSSProperties } from 'react';

export const text4xl = {
	fontSize: '2.25rem',
	lineHeight: '2.5rem',
} as const satisfies CSSProperties;

export const text3xl = {
	fontSize: '1.875rem',
	lineHeight: '2.25rem',
} as const satisfies CSSProperties;

export const text2xl = {
	fontSize: '1.5rem',
	lineHeight: '2rem',
} as const satisfies CSSProperties;

export const textXl = {
	fontSize: '1.25rem',
	lineHeight: '1.75rem',
} as const satisfies CSSProperties;

export const textLg = {
	fontSize: '1.125rem',
	lineHeight: '1.75rem',
} as const satisfies CSSProperties;

export const textMd = {
	fontSize: '1rem',
	lineHeight: '1.5rem',
} as const satisfies CSSProperties;

export const textSm = {
	fontSize: '0.875rem',
	lineHeight: '1.25rem',
} as const satisfies CSSProperties;

export const textXs = {
	fontSize: '0.75rem',
	lineHeight: '1rem',
} as const satisfies CSSProperties;

export const text2xs = {
	fontSize: '0.5rem',
	lineHeight: '.75rem',
} as const satisfies CSSProperties;

export const textLabelSize = {
	fontSize: '0.75rem',
	lineHeight: '0.9rem',
} as const satisfies CSSProperties;
